import React from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import handleModalTitle from "./KanbanModal/handleModalTitle";
import RecruiterKanbanModalContent from "./KanbanModal/recruiter/RecruiterKanbanModalContent";
import EmployerKanbanModalContent from "./KanbanModal/employer/EmployerKanbanModalContent";
import {
  ModalBackdrop,
  ModalWrapper,
  Title,
  TitleText,
  CloseButton,
} from "./styles/kanban-modal-styles";

const KanbanModal = ({
  draggedCardData,
  closeActionModalAfterReset,
  closeActionModalAfterSubmit,
  fetchKanbanData,
  cardData,
  isRecruiter,
  handleCancelRecruiterConfirmation,
  jobCurrencySymbol,
}) => {
  const { cardUpdateId, cardUpdateNewColumn } = draggedCardData;
  const iOS = detect().name === "ios";

  if (cardUpdateNewColumn !== "submitted-candidates") {
    return (
      <ModalBackdrop className="animated fadeIn">
        <ModalWrapper
          iOS={iOS}
          className="animated fadeInDown"
          cardUpdateNewColumn={cardUpdateNewColumn}
        >
          <Title className="animated fadeInDown">
            <TitleText>
              {handleModalTitle(cardUpdateNewColumn, isRecruiter)}
            </TitleText>
            {!isRecruiter && (
              <CloseButton
                onClick={(e) =>
                  isRecruiter
                    ? handleCancelRecruiterConfirmation(e)
                    : closeActionModalAfterReset(e)
                }
              >
                <FontAwesomeIcon icon={faTimes} />
              </CloseButton>
            )}
          </Title>
          {isRecruiter ? (
            <RecruiterKanbanModalContent
              cardUpdateNewColumn={cardUpdateNewColumn}
              cardUpdateId={cardUpdateId}
              closeActionModalAfterReset={closeActionModalAfterReset}
              closeActionModalAfterSubmit={closeActionModalAfterSubmit}
              cardData={cardData}
              fetchKanbanData={fetchKanbanData}
              handleCancelRecruiterConfirmation={
                handleCancelRecruiterConfirmation
              }
              jobCurrencySymbol={jobCurrencySymbol}
              handleModalTitle={handleModalTitle}
            />
          ) : (
            <EmployerKanbanModalContent
              cardUpdateNewColumn={cardUpdateNewColumn}
              cardUpdateId={cardUpdateId}
              closeActionModalAfterReset={closeActionModalAfterReset}
              closeActionModalAfterSubmit={closeActionModalAfterSubmit}
              cardData={cardData}
              fetchKanbanData={fetchKanbanData}
            />
          )}
        </ModalWrapper>
      </ModalBackdrop>
    );
  }
  return null;
};

KanbanModal.propTypes = {
  draggedCardData: PropTypes.shape({
    cardUpdateId: PropTypes.number,
    cardUpdateNewColumn: PropTypes.string,
  }).isRequired,
  closeActionModalAfterReset: PropTypes.func.isRequired,
  closeActionModalAfterSubmit: PropTypes.func.isRequired,
  fetchKanbanData: PropTypes.func.isRequired,
  cardData: PropTypes.shape({}).isRequired,
  isRecruiter: PropTypes.bool.isRequired,
  handleCancelRecruiterConfirmation: PropTypes.func.isRequired,
  jobCurrencySymbol: PropTypes.string.isRequired,
};

export default KanbanModal;
